import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'formatterPremiereDlcFournisseur'
})
export class FormatterPremiereDlcFournisseurPipe implements PipeTransform {

	transform(dlcsFournisseursAAfficher: any, avecAnnee: boolean): string {
		if (dlcsFournisseursAAfficher) {
			const dlcsFournisseurs = dlcsFournisseursAAfficher.split(',');
			let premiereDlcFournisseur = dlcsFournisseurs[0];
			if (!avecAnnee) {
				premiereDlcFournisseur = premiereDlcFournisseur.substring(0, 2) + ' / ' + premiereDlcFournisseur.substring(3, 5);
			}
			return dlcsFournisseurs.length === 1 ? premiereDlcFournisseur : premiereDlcFournisseur + '...';
		}
		return '';
	}

}
